<template>
  <div class="image-editor">
    <div class="image-container" :class="{ 'revers-dimensions': isVertical && !previewMode }">
      <div class="image-holder">
        <naj-loader v-if="resetStyle"></naj-loader>
        <img :id="imageElementId" :src="imageUrl" :alt="imageName" />
      </div>
    </div>
    <div class="image-editor-actions" v-if="!previewMode">
      <v-icon class="action" @click="rotate(90)">mdi-rotate-right</v-icon>
      <v-icon class="action" @click="rotate(-90)">mdi-rotate-left</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: ['imageUrl', 'imageName', 'previewMode'],
  data () {
    return {
      transform: 0,
      imageElementId: 'attachment-image',
      maxWidth: '100%',
      opacity: 1,
      resetStyle: false,
      attachmentCanvasId: 'attachment-canvas',
      image: new Image(),
    };
  },
  computed: {
    isVertical () {
      return (this.transform / 90) % 2 !== 0;
    },
  },
  methods: {
    rotate (rotation) {
      this.transform += rotation;
      this.generateCanvasWithRotate();
    },
    generateCanvasWithRotate () {
      this.image.src = this.imageUrl;
    },
    reset () {
      this.transform = 0;
      this.resetStyle = false;
    },
    imageOnloadCallback () {
      this.resetStyle = true;
      const canvas = document.createElement('canvas');
      var canvasWidth = this.isVertical ? this.image.height : this.image.width;
      var canvasHeight = this.isVertical ? this.image.width : this.image.height;
      canvas.id = this.attachmentCanvasId;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext('2d');
      ctx.translate(canvasWidth / 2, canvasHeight / 2);

      ctx.rotate(Math.PI / (180 / this.transform));

      ctx.drawImage(
        this.image,
        this.image.width / -2,
        this.image.height / -2,
        this.image.width,
        this.image.height
      );

      this.$emit('updateImage', canvas.toDataURL());
      this.reset();
    },
  },
  created () {
    this.image.onload = this.imageOnloadCallback;
  },
};
</script>

<style lang="scss" scoped>
$actionsColWidth: 80px;
$actionsHeight: 56px;
.image-editor {
  height: calc(100% - #{$actionsHeight});
  .image-container {
    height: 100%;
    position: relative;
    min-height: 150px;
    overflow: hidden;
    .image-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      img {
        max-height: 100%;
        display: inline-block;
        &:not(.reset-styles) {
          max-width: 100%;
        }
        &.reset-styles {
          position: absolute;
          opacity: 0;
        }
      }
    }
    &.revers-dimensions {
      position: relative;
      z-index: 50;
      padding-top: 100%;
      .image-holder {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 50;
        text-align: center;
        &:before {
          content: '';
          display: inline-block;
          height: 100%;
          width: 1px;
          vertical-align: middle;
        }
        img {
          &:not(.reset-styles) {
            max-width: calc(100% - 3px);
            max-height: 100%;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .image-editor-actions {
    display: flex;
    justify-content: space-between;
    height: $actionsHeight;
    .action {
      width: calc(50% - 2px);
      height: 54px;
      margin-top: 2px;
      background-color: #f1f2f6;
      color: #000000;
      text-align: center;
      &:hover {
        background-color: #eee;
      }
    }
  }
}
</style>
